import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const externalAPI = createApi({
    baseQuery: fetchBaseQueryCSRF({
        baseUrl: process.env.CROSS_API_URL + '/ext',
    }),
    reducerPath: 'api.ext',
    tagTypes: ['ext'],
    endpoints: (builder) => ({
        getBQCountries: builder.query<{country_name: string, country_code: string, country_language: string}[], void>({
            query: () => ({
                url: '/bq/countries',
            }),
        }),
    }),
});

export const { useGetBQCountriesQuery } = externalAPI;

export default externalAPI;